var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuMembership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 0.75H0.75V25.25H4.875H6.875H19.125H21.125H25.25V0.75ZM21.1204 23.25H23.25V2.75H2.75V23.25H4.87963C5.01108 19.707 7.92492 16.875 11.5 16.875H14.5C18.0751 16.875 20.9889 19.707 21.1204 23.25ZM6.88164 23.25H19.1184C18.9885 20.812 16.9703 18.875 14.5 18.875H11.5C9.02966 18.875 7.01152 20.812 6.88164 23.25ZM13 7.25C11.2742 7.25 9.875 8.64916 9.875 10.375V11.5C9.875 13.2258 11.2742 14.625 13 14.625C14.7258 14.625 16.125 13.2258 16.125 11.5V10.375C16.125 8.64916 14.7258 7.25 13 7.25ZM7.875 10.375C7.875 7.54459 10.1696 5.25 13 5.25C15.8304 5.25 18.125 7.54459 18.125 10.375V11.5C18.125 14.3304 15.8304 16.625 13 16.625C10.1696 16.625 7.875 14.3304 7.875 11.5V10.375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMembership);
export default __webpack_public_path__ + "static/media/icon_menu_membership.404d3038.svg";
export { ForwardRef as ReactComponent };